import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../components/Login';
import BanHangPage from '../pages/quan_ly_ban_hang/BanHang';
import LichSuBanHangPage from '../pages/quan_ly_ban_hang/LichSuBanHang';
import QuanLyBepPage from '../pages/quan_ly_bep/QuanLyBep';
import DanhSachMonAnPage from '../pages/quan_ly_bep/DanhSachMonAn';
import { getHomePath, type UserRole } from '../utils/userRole';

const isLoggedIn = () => Boolean(localStorage.getItem('access_token'));

const ProtectedRoute = ({ children, allowedRole }: { children: JSX.Element; allowedRole: UserRole }) => {
  if (!isLoggedIn()) return <Navigate to="/login" replace />;
  if (localStorage.getItem('user_type_key') !== allowedRole) {
    return <Navigate to={getHomePath()} replace />;
  }
  return children;
};

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={isLoggedIn() && getHomePath() !== '/login' ? <Navigate to={getHomePath()} replace /> : <Login />} />
      <Route
        path="/banhang"
        element={
          <ProtectedRoute allowedRole="BAN_HANG">
            <BanHangPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lich-su-ban-hang"
        element={
          <ProtectedRoute allowedRole="BAN_HANG">
            <LichSuBanHangPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quan-ly-bep"
        element={
          <ProtectedRoute allowedRole="BEP">
            <QuanLyBepPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quan-ly-bep/danh-sach-mon-an"
        element={
          <ProtectedRoute allowedRole="BEP">
            <DanhSachMonAnPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to={isLoggedIn() ? getHomePath() : '/login'} replace />} />
      <Route path="*" element={<Navigate to={isLoggedIn() ? getHomePath() : '/login'} replace />} />
    </Routes>
  );
}
